import type { QueryClient } from "@tanstack/react-query";
import { UsersApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export async function prefetchUserGet(
  id: number,
  queryClient: QueryClient,
  accessToken?: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching user");
  }

  const service = createAuthenticatedApi(UsersApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.UserGet, id],
    queryFn: () => service.apiUsersIdGet({ id: id }),
    staleTime: 5 * 60 * 1000,
  });

  return queryClient;
}
